module.exports = __webpack_public_path__ + "media/images/live-tour-6aa4dbb65d241aad3918075e32c4ebc3.jpg";